import { Collapse, IconButton, TableBody, TableCell, TableRow } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { formatDollarsCurrency } from "../OptionsTrading/helpers";
import { StatusChip } from "./StatusChip";
import { isLimitOrder, isMultiLegOrder } from "./OrdersTable";
import { useState } from "react";
import { getContractType } from "./SharedTableContent";

const OpenOrders = ({ pendingOrders, navigateTab, findTradeByOrderId }) => {
  const [openRowId, setOpenRowId] = useState(null);

  const handleExpandClick = (orderId) => {
    setOpenRowId(prevId => prevId === orderId ? null : orderId);
  };

  console.log("pending orders", pendingOrders);
  return (
    <>
      {pendingOrders.map((order) => {
        const isMultiLeg = isMultiLegOrder(order);
        const isLimit = isLimitOrder(order);
        const associatedTrade = findTradeByOrderId(order.external_order_id);
        console.log(associatedTrade);

        return (
          <>
            <TableRow key={order.id} className="body2">
              <TableCell id="strategy">
                <div className="flex">
                  {isLimit && (
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleExpandClick(order.id)}
                    >
                      {openRowId === order.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  )}
                  <div>
                    <div className="caption">
                      {isMultiLeg ? "Multi Leg • " : "Single Leg • "}
                      {associatedTrade?.trade_idea?.symbol}
                    </div>
                    <div className="body2">{associatedTrade?.trade_idea?.option_strategy}</div>
                  </div>
                </div>
              </TableCell>

              {isMultiLeg
                ? (
                    <TableCell id="contractType">
                      {associatedTrade?.trade_idea?.legs.map((leg, index) => (
                        <TableRow key={`leg-${order.id}-${index}`}>
                          <TableCell className="nested-row">{getContractType(leg)}</TableCell>
                        </TableRow>
                      ))}
                    </TableCell>
                  )
                : (
                    <TableCell>{getContractType(associatedTrade?.trade_idea?.legs[0])}</TableCell>
                  )}

              {isMultiLeg
              && (
                <TableCell id="qty">
                  {order.legs?.map((leg, index) => (
                    <TableRow key={`leg-${associatedTrade.id}-${index}`}>
                      <TableCell className="nested-row">
                        {leg.exec_quantity}
                        {" "}
                        /
                        {" "}
                        {leg.exec_quantity + leg.remaining_quantity}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableCell>
              )}
              {isLimit && (
                <TableCell id="qty">
                  {order.legs[0].exec_quantity}
                  {" "}
                  /
                  {order.legs[0].exec_quantity + order.legs[0].remaining_quantity}
                </TableCell>
              )}

              {!isMultiLeg && !isLimit && (
                <TableCell id="qty">
                  {order.exec_quantity}
                  {" "}
                  /
                  {" "}
                  {order.total_quantity}
                </TableCell>
              )}
              {isMultiLeg
                ? (
                    <TableCell>
                      {order.legs?.map((leg, index) => (
                        <TableRow key={`leg-${order.id}-${index}`}>
                          <TableCell className="nested-row">
                            <StatusChip status={leg.status} handleStatusClick={navigateTab} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableCell>
                  )
                : (
                    <TableCell><StatusChip status={order.status} handleStatusClick={navigateTab} /></TableCell>
                  )}
              <TableCell></TableCell>
              <TableCell>{formatDollarsCurrency(associatedTrade?.preview_result?.cost)}</TableCell>
              <TableCell id="orderType">{isLimit ? "Limit" : "Market"}</TableCell>
            </TableRow>
            {isLimit && openRowId === order.id && (
              <>
                <TableRow className="collapsible-row-background">
                  <TableCell colSpan={7}>
                    <Collapse in={openRowId === order.id} timeout="auto" unmountOnExit>
                      <TableBody>
                        {order.legs
                          ?.filter(leg => leg.side !== "buy_to_open")
                          .map((leg, index) => (
                            <TableRow key={`leg-${associatedTrade.id}-${index}`}>
                              <TableCell style={{ width: "15%" }} className="collapsible-row"></TableCell>
                              <TableCell style={{ width: "13%" }} className="collapsible-row"></TableCell>
                              {/* for column 2 */}
                              <TableCell style={{ width: "13%" }} id="qty" className="collapsible-row">
                                {leg.exec_quantity}
                                {" "}
                                /
                                {leg.exec_quantity + leg.remaining_quantity}
                              </TableCell>
                              <TableCell style={{ width: "11%" }} id="status" className="collapsible-row">
                                <StatusChip status={leg.status} handleStatusClick={navigateTab} />
                              </TableCell>
                              <TableCell style={{ width: "11%" }} id="unitPrice" className="collapsible-row">
                                {leg.type === "stop" ? leg.stop_price : leg.price}
                              </TableCell>
                              <TableCell style={{ width: "12%" }} id="estCost" className="collapsible-row">-</TableCell>
                              <TableCell style={{ width: "11%" }} id="orderType" className="collapsible-row">
                                {leg.type === "stop" ? "Stop Loss" : "Take Profit"}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            )}
          </>
        );
      })}
    </>
  );
};

export default OpenOrders;
